<template>
  <div class="container-fluid">
    <div class="page-wrapper">
      <div slot="header" class="page-wrapper-header">
        <div class="row">
          <div class="col-6">
            <h3 class="mb-0">
              {{ $t("CONTRACTS.CONTRACTS_LIST") }}
            </h3>
          </div>
          <div class="col-6 text-right">
            <base-button
              class="elite-button add"
              icon
              size="sm"
              @click="openContractCreateModal"
              v-if="$currentUserCan($permissions.PERM_CREATE_CONTRACTS)"
            >
              <span class="btn-inner--icon">
                <i class="far fa-plus-circle"></i>
              </span>
              <span class="btn-inner--text">
                {{ $t("CONTRACTS.ADD_CONTRACT") }}
              </span>
            </base-button>

            <notification-subscription
              v-if="$currentUserCan($permissions.PERM_VIEW_CONTRACTS)"
              :objectType="'contracts'"
              :events="{
                CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
              }"
            />
          </div>
        </div>
      </div>

      <contract-list-table
        @onViewContract="openContractViewModal"
        @onEditContract="openContractEditModal"
        @onDeleteContract="deleteContract"
        :key="renderKey * 100"
      />

      <div
        v-if="isViewContractModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isViewContractModalOpened ? 'show' : 'hide']"
        :key="renderKey * 200"
      >
        <div
          class="resizable-wrapper-content w-100"
          v-resizable-modal="'CONTRACT_VIEW'"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("CONTRACTS.VIEW_CONTRACT") }}
              </h1>
            </div>

            <div class="resizable-wrapper-content-header-right">
              <notification-subscription
                v-if="openContract"
                :objectType="'contracts'"
                :objectId="openContract.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />

              <!-- <base-dropdown
                title-classes="btn dropdown-button"
                menu-on-right
                :has-toggle="false"
              >
                <template slot="title">
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <button
                  class="edit"
                  @click="openContractEditModal(openContract)"
                >
                  <i class="fal fa-edit"></i>
                  <span>{{ $t("COMMON.EDIT") }}</span>
                </button>
                <button
                  class="delete"
                  @click="deleteContract(openContract)"
                >
                  <i class="fal fa-trash-alt"></i>
                  <span>{{ $t("COMMON.DELETE") }}</span>
                </button>
              </base-dropdown> -->

              <button class="close" @click="closeContractModal">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>

          <div class="resizable-wrapper-content-body">
            <view-contract-component
              v-if="openContract"
              :contractId="openContract.id"
              @onEditContract="openContractEditModal"
              @onDeleteContract="deleteContract"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isEditContractModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isEditContractModalOpened ? 'show' : 'hide']"
        :key="renderKey * 300"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'CONTRACT'"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("CONTRACTS.EDIT_CONTRACT") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <base-dropdown
                title-classes="btn dropdown-button"
                menu-on-right
                :has-toggle="false"
              >
                <template slot="title">
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <button
                  class="view"
                  @click="openContractViewModal(openContract)"
                >
                  <i class="fal fa-expand-alt"></i>
                  <span>{{ $t("COMMON.VIEW") }}</span>
                </button>
              </base-dropdown>
              <button class="close" @click="closeContractModal">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <edit-contract-component
              v-if="openContract"
              :contractId="openContract.id"
              @onViewContract="openContractViewModal"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isAddContractModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isAddContractModalOpened ? 'show' : 'hide']"
        :key="renderKey * 400"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'CONTRACT'"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("CONTRACTS.ADD_CONTRACT") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <button class="close" @click="closeContractModal">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <add-contract-component
              @onViewContract="openContractViewModal"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Button } from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import {
  QUERY_ACTIONS_VIEW,
  QUERY_ACTIONS_EDIT,
  QUERY_ACTIONS_ADD,
} from "@/constants/common";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import ContractListTable from "./partials/ContractListTable.vue";
import EditContractComponent from "./components/EditContractComponent.vue";
import AddContractComponent from "./components/AddContractComponent.vue";
import ViewContractComponent from "./components/ViewContractComponent.vue";

export default {
  layout: "DashboardLayout",

  components: {
    ContractListTable,
    NotificationSubscription,
    EditContractComponent,
    AddContractComponent,
    ViewContractComponent,
    [Button.name]: Button,
  },

  mixins: [requestErrorMixin],

  computed: {},

  watch: {},

  data() {
    const contractId = this.$route.query.id;
    const action = this.$route.query.action;
    let isViewContractModalOpened = false;
    let isEditContractModalOpened = false;
    let isAddContractModalOpened = false;
    let openContract = null;
    if (contractId && action) {
      if (action === QUERY_ACTIONS_VIEW) {
        isViewContractModalOpened = true;
      } else if (action === QUERY_ACTIONS_EDIT) {
        isEditContractModalOpened = true;
      }
      openContract = { id: contractId };
    } else if (action === QUERY_ACTIONS_ADD) {
      isAddContractModalOpened = true;
    }
    return {
      isViewContractModalOpened: isViewContractModalOpened,
      isEditContractModalOpened: isEditContractModalOpened,
      isAddContractModalOpened: isAddContractModalOpened,
      openContract: openContract,
      renderKey: 1,
    };
  },

  methods: {
    openContractCreateModal() {
      this.closeContractModal();
      this.isAddContractModalOpened = true;

      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List Contracts",
          query: { action: QUERY_ACTIONS_ADD },
        }).href
      );
    },
    openContractViewModal(contract, reRender = false) {
      this.closeContractModal();
      this.openContract = contract;
      this.isViewContractModalOpened = true;
      if (reRender) {
        this.renderKey++;
      }

      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List Contracts",
          query: { id: this.openContract.id, action: QUERY_ACTIONS_VIEW },
        }).href
      );
    },

    openContractEditModal(contract) {
      this.closeContractModal();
      this.openContract = contract;
      this.isEditContractModalOpened = true;

      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List Contracts",
          query: { id: this.openContract.id, action: QUERY_ACTIONS_EDIT },
        }).href
      );
    },
    closeContractModal() {
      this.isAddContractModalOpened = false;
      this.isViewContractModalOpened = false;
      this.isEditContractModalOpened = false;
      this.openContract = null;

      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List Contracts",
          query: {},
        }).href
      );
    },

    async deleteContract(contract) {
      const confirmation = await swal.fire({
        text: this.$t("CONTRACTS.DELETE_THIS_CONTRACT"),
        type: "question",
        customClass: {
          popup: "delete-popup",
        },
        buttonsStyling: false,
        showCancelButton: true,
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonText:
          this.$t("COMMON.YES") + ", " + this.$t("COMMON.DELETE"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch(
            "contracts/destroy",
            contract.id
          );
          this.renderKey++;
          this.closeContractModal();
          this.$notify({
            type: "success",
            message: this.$t("CONTRACTS.CONTRACT_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
